import { FaFacebook, FaThumbsUp, FaComment, FaShare } from "react-icons/fa";
import { IoIosMore } from "react-icons/io";
import { FaSquareInstagram } from "react-icons/fa6";
import { AiOutlineDelete } from "react-icons/ai";
import { RiEditFill } from "react-icons/ri";
import { useEffect, useRef, useState } from "react";
import { findPostById } from "../../redux/slices/apiSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaBell } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

export default function FacebookPostCard({
  post,
  type,
  file,
  fileType = "image",
  content,
  username,
  editAndDel = false,
  editPost,
  editedPost,
  caption,
  postType = "",
  width = null,
}) {
  const [postAction, setPostAction] = useState(null);
  const menuRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showTooltip, setShowTooltip] = useState(false);
  const [showFullCap, setShowFullCap] = useState(false);
  const [tooltipHeight, setTooltipHeight] = useState(0);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setPostAction(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlePostClick = (postId) => {
    if (editPost) {
      return;
    }
    dispatch(findPostById({ postId }));
    navigate(`/social_calendar/edit_post/${postId}`);
  };
  useEffect(() => {
    if (showFullCap && tooltipRef.current) {
      setTooltipHeight(tooltipRef.current.offsetHeight);
    }
  }, [showFullCap]);

  return (
    <div className="max-w-[-webkit-fill-available] min-w-[200px]   transition-transform duration-300 ease-in-out  bg-white border border-gray-300 rounded-lg shadow-lg ">
      <div className="flex items-start justify-between p-3">
        <div className="flex items-start  space-x-2">
          <div
            className={`p-[2px] ${
              type === "Facebook"
                ? "border-blue-300 border-[2px]"
                : "border-transparent border-[1px] bg-gradient-to-r from-[#833ab4] via-[#fd1d1d] to-[#fcb045]"
            } rounded-full `}
          >
            <div
              className={`bg-white rounded-full ${
                type === "Facebook" ? "" : "p-[2px]"
              } `}
            >
              {type === "Facebook" ? (
                <FaFacebook className="text-blue-600 text-xl" />
              ) : (
                <FaSquareInstagram className="text-pink-600 text-lg" />
              )}
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold">
              {type === "Facebook" ? "Facebook " : "Instagram "}
              Post
            </p>
            <p className="text-[8px] text-gray-500">Sponsored</p>
          </div>
        </div>
        <div class="flex items-center gap-1 ml-auto">
          <div
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            className="relative cursor-pointer"
          >
            <FaBell className="text-gray-400" />
            {showTooltip && (
              <div className="absolute top-6 text-[9px] -right-5 bg-white text-gray-500 text-wrap rounded shadow py-1 px-2 z-10 break-words max-w-[30px] min-w-0 sm:min-w-[150px]">
                Impression and clicks will be reflected by T-1 Day
              </div>
            )}
          </div>
          <button ref={menuRef} className=" relative z-50 bg-white">
            <IoIosMore
              className="text-2xl text-gray-600 hover:text-[#007aff] rounded-full p-1 hover:bg-[#e6f7ff] cursor-pointer"
              onClick={() =>
                setPostAction((prev) => (prev === post?.id ? null : post?.id))
              }
            />
            {postAction === post?.id && editAndDel && (
              <div className="z-50 right-0 overflow-hidden rounded border-gray-300 border flex flex-col gap-1 items-start py-2 absolute w-[130px] bg-white shadow-2xl">
                {postType === "upcoming" && (
                  <button
                    className="flex px-3 text-sm py-1 hover:bg-[#e6f7ff] hover:font-bold hover:text-[#007aff]  gap-3 w-full items-center"
                    onClick={(e) => {
                      handlePostClick(post._id);
                      setPostAction(null);
                    }}
                  >
                    <RiEditFill className="text-lg font-bold" />
                    Edit
                  </button>
                )}
                <button
                  className="flex px-3 text-sm py-1 hover:bg-[#e6f7ff] hover:font-bold hover:text-[#007aff]  gap-3 w-full items-center"
                  onClick={(e) => {
                    setPostAction(null);
                  }}
                >
                  <AiOutlineDelete className="text-lg" /> Delete
                </button>
              </div>
            )}
          </button>
        </div>
      </div>
      {/* {file ? (
        <div
          onClick={() => handlePostClick(post._id)}
          className="mt-2 flex flex-col justify-center align min-h-[170px]"
        >
          {fileType === "image" ? (
            <img
              src={file}
              alt="preview"
              className={`w-full h-[170px]  mx-auto object-center `}
            />
          ) : (
            <video
              src={file}
              controls
              className={`w-full h-[170px]  mx-auto object-center `}
            />
          )}
        </div>
      ) : (
        <></>
      )} */}
      {Array.isArray(file) && file.length > 0 && (
        <div
          onClick={(e) => {
            const el = e.target;
            if (
              el.closest(".swiper-button-prev") ||
              el.closest(".swiper-button-next")
            ) {
              e.stopPropagation();
              return;
            }
            handlePostClick(post._id);
          }}
          className={`mt-2 flex flex-col justify-center ${
            width ? width : ""
          } min-h-[200px]`}
        >
          <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={10}
            slidesPerView={1}
            className="w-full max-w-[250px] h-[200px]"
          >
            {file.map((media, index) => (
              <SwiperSlide
                key={index}
                className="flex flex-col items-center justify-center w-full  h-[200px]"
              >
                {media.type === "image" ? (
                  <img
                    src={media?.url}
                    alt={`media-${index}`}
                    className="m-auto max-h-full w-auto object-contain"
                  />
                ) : (
                  <video
                    src={media?.url}
                    controls
                    className="m-auto max-h-full w-auto object-contain"
                  />
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}

      {type === "Instagram" && (
        <div className="mt-2  text-xs flex justify-between px-3">
          <div className="flex gap-2 items-center">
            <svg
              width="20"
              height="20"
              viewBox="0 0 101 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7138 54.5251L49.97 91.4005C50.3656 91.8264 51.0397 91.8264 51.4353 91.4005L85.6916 54.5251C94.4751 45.07 94.4751 29.7402 85.6916 20.2851C76.908 10.8299 62.667 10.8299 53.8835 20.2851L51.4353 22.9204C51.0397 23.3463 50.3656 23.3463 49.97 22.9204L47.5219 20.2851C38.7383 10.8299 24.4973 10.8299 15.7138 20.2851C6.93021 29.7402 6.93021 45.07 15.7138 54.5251Z"
                stroke="black"
                stroke-width="8.31532"
              />
            </svg>

            <svg
              width="20"
              height="20"
              viewBox="0 0 101 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="path-1-outside-1_1_12"
                maskUnits="userSpaceOnUse"
                x="8.41656"
                y="8.0721"
                width="84"
                height="84"
                fill="black"
              >
                <rect
                  fill="white"
                  x="8.41656"
                  y="8.0721"
                  width="84"
                  height="84"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M75.5558 72.5012C80.8012 66.618 83.9888 58.8604 83.9888 50.3582C83.9888 31.9748 69.0861 17.0721 50.7027 17.0721C32.3193 17.0721 17.4166 31.9748 17.4166 50.3582C17.4166 68.7417 32.3193 83.6444 50.7027 83.6444C57.0264 83.6444 62.9383 81.8809 67.9734 78.819L77.3421 80.8286L75.5558 72.5012Z"
                />
              </mask>
              <path
                d="M75.5558 72.5012L69.3492 66.9675L66.5402 70.1181L67.4255 74.2452L75.5558 72.5012ZM67.9734 78.819L69.7174 70.6886L66.481 69.9944L63.6528 71.7142L67.9734 78.819ZM77.3421 80.8286L75.5981 88.959L88.169 91.6555L85.4725 79.0846L77.3421 80.8286ZM75.6735 50.3582C75.6735 56.7418 73.289 62.5486 69.3492 66.9675L81.7625 78.0349C88.3134 70.6874 92.3041 60.9789 92.3041 50.3582H75.6735ZM50.7027 25.3874C64.4937 25.3874 75.6735 36.5672 75.6735 50.3582H92.3041C92.3041 27.3824 73.6785 8.75678 50.7027 8.75678V25.3874ZM25.7319 50.3582C25.7319 36.5672 36.9117 25.3874 50.7027 25.3874V8.75678C27.7269 8.75678 9.10125 27.3824 9.10125 50.3582H25.7319ZM50.7027 75.329C36.9117 75.329 25.7319 64.1492 25.7319 50.3582H9.10125C9.10125 73.3341 27.7269 91.9597 50.7027 91.9597V75.329ZM63.6528 71.7142C59.8829 74.0068 55.4599 75.329 50.7027 75.329V91.9597C58.593 91.9597 65.9937 89.755 72.2939 85.9237L63.6528 71.7142ZM66.2294 86.9493L75.5981 88.959L79.0861 72.6982L69.7174 70.6886L66.2294 86.9493ZM85.4725 79.0846L83.6862 70.7572L67.4255 74.2452L69.2117 82.5726L85.4725 79.0846Z"
                fill="black"
                mask="url(#path-1-outside-1_1_12)"
              />
            </svg>

            <svg
              width="20"
              height="20"
              viewBox="0 0 79 68"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29.7928 29.6126L36.9775 61.944C37.385 63.7778 39.8229 64.1734 40.7894 62.5626L73.638 7.81506C74.4693 6.42947 73.4712 4.66668 71.8554 4.66668H6.30876C4.37876 4.66668 3.49052 7.06785 4.95588 8.32388L29.7928 29.6126ZM29.7928 29.6126L71.3693 6.74551"
                stroke="black"
                stroke-width="8.31532"
              />
            </svg>
          </div>

          <svg
            width="22"
            height="22"
            viewBox="0 0 101 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.1621 78.4168V17.0721H75.054V78.4168L53.1675 58.719C51.4282 57.1536 48.7879 57.1536 47.0486 58.719L25.1621 78.4168Z"
              stroke="black"
              stroke-width="8.31532"
            />
          </svg>
        </div>
      )}
      {/* Impressions */}
      <div className="px-3">
        {type !== "Instagram" && (
          <div className=" flex mt-2 pb-1 gap-2 items-center">
            {/* <div className="flex gap-1  text-gray-500 text-[8px]  text-nowrap`">
              <span className=" text-nowrap">
                Reach <strong className="text-[10px]">100K</strong>
              </span>
              <span className="text-nowrap">
                Impressions <strong className="text-[10px]">1000k</strong>
              </span>
            </div> */}
            <div className="flex gap-2 justify-between  text-gray-600 text-[8px] text-nowrap">
              <div className="flex items-center space-x-1">
                <FaThumbsUp className="text-gray-600 text-lg" />
                {/* <span>234</span> */}
              </div>
              <div className="flex items-center space-x-1">
                <FaComment className="text-gray-600 text-lg" />
                {/* <span>300</span> */}
              </div>
              <div className="flex items-center space-x-1">
                <FaShare className="text-gray-600 text-lg" />
                {/* <span>50</span> */}
              </div>
            </div>
          </div>
        )}
        <div
          className="mt-2 mb-3 text-[10px] relative max-w-full break-words"
          onMouseEnter={() => setShowFullCap(true)}
          onMouseLeave={() => setShowFullCap(false)}
        >
          <span className="font-semibold">
            {username ? username : "Username"}
          </span>{" "}
          <span className="text-wrap cursor-pointer border-none outline-none">
            {caption && postType !== "newPost"
              ? caption.slice(0, 50) + "..."
              : caption}
          </span>
          {showFullCap && caption && postType !== "newPost" && (
            <div
              ref={tooltipRef}
              className="absolute transition-all ease-in-out duration-1000 z-50 left-0 mt-1 bg-white shadow-lg border border-gray-300 rounded-md p-2 text-[10px] text-gray-700 w-[200px] max-w-xs break-words"
              style={{ top: `-${tooltipHeight + 8}px` }} // +8px for spacing
            >
              {caption}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
